var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendingHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2133.000000pt",
    height: "2133.000000pt",
    viewBox: "0 0 2133.000000 2133.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,2133.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10585 19606 c-95 -30 -185 -90 -540 -355 -509 -381 -1205 -933 -1520 -1207 -667 -579 -1870 -1783 -2441 -2444 -197 -228 -506 -634 -736 -965 -1084 -1562 -1721 -3160 -1877 -4706 -35 -342 -45 -575 -45 -974 1 -569 39 -974 140 -1475 298 -1474 1130 -2907 2289 -3938 1361 -1212 3146 -1869 4965 -1829 563 13 1065 79 1585 208 1774 442 3259 1487 4280 3013 685 1024 1084 2138 1197 3341 17 180 17 835 0 1000 -55 543 -150 997 -317 1530 -234 742 -645 1570 -1112 2237 -201 287 -435 558 -516 597 -85 41 -238 37 -332 -9 -48 -23 -144 -107 -198 -173 l-37 -46 16 -463 c21 -630 22 -1073 0 -1248 -30 -244 -103 -565 -136 -595 -33 -30 -44 4 -120 340 -363 1621 -1187 4573 -1489 5340 -57 143 -111 204 -226 257 -41 18 -67 22 -145 22 -134 -1 -238 -35 -313 -104 -92 -84 -111 -131 -327 -810 -312 -978 -826 -2036 -1245 -2560 -207 -258 -506 -572 -587 -614 -49 -26 -74 -14 -123 59 -148 223 -327 827 -364 1225 -39 419 44 1332 214 2360 120 722 244 1297 419 1950 98 364 129 521 130 660 0 96 -3 122 -20 160 -31 66 -68 106 -143 150 -125 74 -231 96 -326 66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingHover);
export default __webpack_public_path__ + "static/media/trending-hover.04a1f79ac4dbf4b2d09286f52c47592b.svg";
export { ForwardRef as ReactComponent };